import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ScrollableTabsButtonVisible from './ScrollableTabsButtonVisible';
import ClientProvider from './client';
export default createDemo(import.meta.url, ScrollableTabsButtonVisible, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tabs/demos/scrollable-button-visible/ScrollableTabsButtonVisible.tsx",
    "fileName": "ScrollableTabsButtonVisible.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tabs, { tabsClasses } from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\n\nexport default function ScrollableTabsButtonVisible() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [value, setValue] = React.useState(0);\n\n  const handleChange = (event: React.SyntheticEvent, newValue: number) => {\n    setValue(newValue);\n  };\n\n  return (\n    <Box\n      sx={{\n        flexGrow: 1,\n        maxWidth: { xs: 320, sm: 480 },\n        bgcolor: 'background.paper',\n      }}\n    >\n      <Tabs\n        value={value}\n        onChange={handleChange}\n        variant=\"scrollable\"\n        scrollButtons\n        aria-label=\"visible arrows tabs example\"\n        sx={{\n          [`& .${tabsClasses.scrollButtons}`]: {\n            '&.Mui-disabled': { opacity: 0.3 },\n          },\n        }}\n      >\n        <Tab label=\"Item One\" />\n        <Tab label=\"Item Two\" />\n        <Tab label=\"Item Three\" />\n        <Tab label=\"Item Four\" />\n        <Tab label=\"Item Five\" />\n        <Tab label=\"Item Six\" />\n        <Tab label=\"Item Seven\" />\n      </Tabs>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 43,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tabs, { tabsClasses } from '@mui/material/Tabs';\nimport Tab from '@mui/material/Tab';\n\nexport default function ScrollableTabsButtonVisible() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [value, setValue] = React.useState(0);\n\n  const handleChange = (event: React.SyntheticEvent, newValue: number) => {\n    setValue(newValue);\n  };\n\n  return (\n    <Box\n      sx={{\n        flexGrow: 1,\n        maxWidth: { xs: 320, sm: 480 },\n        bgcolor: 'background.paper',\n      }}\n    >\n      <Tabs\n        value={value}\n        onChange={handleChange}\n        variant=\"scrollable\"\n        scrollButtons\n        aria-label=\"visible arrows tabs example\"\n        sx={{\n          [`& .${tabsClasses.scrollButtons}`]: {\n            '&.Mui-disabled': { opacity: 0.3 },\n          },\n        }}\n      >\n        <Tab label=\"Item One\" />\n        <Tab label=\"Item Two\" />\n        <Tab label=\"Item Three\" />\n        <Tab label=\"Item Four\" />\n        <Tab label=\"Item Five\" />\n        <Tab label=\"Item Six\" />\n        <Tab label=\"Item Seven\" />\n      </Tabs>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 43,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Tabs",
      "@mui/material/Tab"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
